export const partnerDocumentsViewInitValue = {
  data: {
    certificateValueSharesDocuments: [],
    otherDocuments: [],
    sharesOwnershipDocument: null,
    partnerId: '',
    partnerName: '',
    isLoading: false,
  },
  actions: {
    handleUploadDocument: () => {},
    handleRemoveDocument: async () => {},
  },
};
